import { SectionHeader } from "../../SectionHeader";
import { ModuleGrid } from "../../../layouts/ModuleGrid";
import { useIsPortraitMobile } from "../../../hooks/useIsPortraiteMobile";
import TiltMessage from "../../../components/feedback/TiltMessage";
import { useMemo, useState } from "react";
import { MonthYearPicker } from "../../ui/month-Year-Picker";
import { format/* , startOfMonth, endOfMonth */ } from "date-fns";
import { WholesaleMarketingPromo } from "../components/wholesale-marketingpromo";
/* import { useAccountingWholesale } from "../hooks/useAccountingWholesale";
import { useWholesaleSales } from "../hooks/useSalesWholesale"; */
import { useWholesaleDataCheck } from "../hooks/useWholesaleDataCheck";
import { FileWarning, TriangleAlert } from "lucide-react";
import { useMarketingWholesalePromo } from "../hooks/useMarketingWholesalePromo";

export function WholesaleMarketing() {
    const now = new Date();
    const [selectedDate, setSelectedDate] = useState<Date | undefined>(new Date(now.getFullYear(), now.getMonth()));
    const formattedDate = selectedDate ? format(selectedDate, "yyyy-MM") : "";
    const showTiltMessage = useIsPortraitMobile();
    /* const startDate = format(startOfMonth(new Date(selectedDate || now)), "yyyy-MM-dd");
    const endDate = format(endOfMonth(new Date(selectedDate || now)), "yyyy-MM-dd"); */

    /* const { data: accountingData } = useAccountingWholesale("month");
    const { data: salesData } = useWholesaleSales(startDate, endDate); */
    const { data: marketingData } = useMarketingWholesalePromo(formattedDate, 40);

    /* const revenueData = accountingData?.revenue_overview;
    const wholesaleCategoryData = salesData?.wholesale_category_performance || []; */
    const promoData = marketingData || [];
    // Use the combined data check hook
    /* const { hasDataForSelectedMonth: hasRevenueData, hasAnyData: hasRevenueAnyData } = useWholesaleDataCheck(
        revenueData,
        { selectedMonth: formattedDate }
    ); */
    const { hasAnyData: hasPromoData } = useWholesaleDataCheck(promoData);
    const hasDataForSelectedMonth = hasPromoData;

    const isCurrentMonthIncomplete = useMemo(() => {
        if (!selectedDate) return false;
        const selectedMonthStart = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
        const selectedMonthEnd = new Date(selectedDate.getFullYear(), selectedDate.getMonth() + 1, 0);
        return now >= selectedMonthStart && now <= selectedMonthEnd && now.getDate() < selectedMonthEnd.getDate();
    }, [selectedDate, now]);

    return (
        <div>
            <TiltMessage show={showTiltMessage} />
            <div className={showTiltMessage ? "blur-sm pointer-events-none" : ""}>
                <SectionHeader title="Wholesale Marketing" />
                <div className="flex flex-row items-center justify-between w-full">
                    <div className="mb-4">
                        <MonthYearPicker selected={selectedDate} onChange={setSelectedDate} />
                    </div>
                    <div>
                        {!hasDataForSelectedMonth && (
                            <div className="text-sm text-red-600 bg-white/70 dark:bg-black/70 rounded-xl shadow-xl-soft px-3 py-2 mb-4 flex flex-row items-center">
                                <FileWarning /> Missing file uploads for the selected month.
                            </div>
                        )}
                        {isCurrentMonthIncomplete && (
                            <div className="text-sm text-yellow-200 bg-white/70 dark:bg-black/70 rounded-xl shadow-xl-soft px-3 py-2 flex flex-row items-center">
                                <TriangleAlert /> The current month is incomplete.
                            </div>
                        )}
                    </div>
                </div>
                <ModuleGrid>
                    <div className="col-span-6 flex flex-col h-full">
                        <WholesaleMarketingPromo month={formattedDate} />
                    </div>
                </ModuleGrid>
            </div>
        </div>
    );
}